export const EVENTS = {
  // Eventos de navegação
  PAGE_VIEW: 'PageView',

  // Eventos de e-commerce
  VIEW_ITEM_LIST: 'view_item_list',
  VIEW_CONTENT: 'ViewContent',
  SELECT_ITEM: 'select_item',
  ADD_TO_CART: 'AddToCart',
  BEGIN_CHECKOUT: 'begin_checkout',
  INITIATE_CHECKOUT: 'InitiateCheckout',
  ADD_SHIPPING_INFO: 'add_shipping_info',
  ADD_PAYMENT_INFO: 'AddPaymentInfo',
  PURCHASE: 'Purchase',
  // PRAT-19: etapas do funil que ainda não tinham evento
  SEARCH: 'search',
  REMOVE_FROM_CART: 'remove_from_cart',
  SIGN_UP: 'sign_up',
  LOGIN: 'login',
  // PRAT-83: contato com a loja (WhatsApp) — Lead na Meta.
  LEAD: 'lead',

  // Eventos de status de pedido
  ORDER_CREATED: 'order_created',
  ORDER_ACCEPTED: 'order_accepted',
  ORDER_OUT_FOR_DELIVERY: 'order_out_for_delivery',
  ORDER_READY: 'order_ready',
  ORDER_DELIVERED: 'order_delivered',
  ORDER_CANCELED: 'order_canceled',

  // Eventos de marketing
  PRATIGO_FOOTER_CLICK: 'pratigo_footer_click',

  // Eventos do Clube PratiGO (fidelidade)
  LOYALTY_ENTRY_CLICK: 'loyalty_entry_click',
  LOYALTY_DASHBOARD_VIEW: 'loyalty_dashboard_view',
  LOYALTY_PRODUCT_VIEW: 'loyalty_product_view',
  LOYALTY_PRODUCT_REDEEM: 'loyalty_product_redeem',
  LOYALTY_STATEMENT_VIEW: 'loyalty_statement_view',

  // Eventos de indicação (divulgação do app)
  REFERRAL_ENTRY_CLICK: 'referral_entry_click',
  REFERRAL_PAGE_VIEW: 'referral_page_view',
  REFERRAL_SHARE_CLICK: 'referral_share_click',
  REFERRAL_LINK_COPY: 'referral_link_copy',
  // Card de indicação pós-pedido (exibido na página de status/sucesso)
  REFERRAL_ORDER_CARD_VIEW: 'referral_order_card_view',
};
